<template>
  <div class="header">
    <h1 class="subtitle has-text-centered">
      <span class="is-pulled-left">
        <router-link class="button" tag="button" to="/dashboard">
          <b-icon icon="arrow-alt-circle-left"></b-icon>
        </router-link>
      </span>
      &nbsp;
      {{ `${storeBeingManaged.storeInfo.name}` }}
    </h1>
    <hr />
  </div>
</template>

<script>
export default {
  props: ["storeBeingManaged"]
};
</script>

<style scoped>
.header {
  position: sticky;
}
hr {
  background-color: hsl(0, 0%, 71%);
}
</style>
